const RED = "#ff3c44";
const RED_SHADES_002 = "#cc3036";
const RED_SHADES_004 = "#992429";
const RED_SHADES_006 = "#66181b";
const RED_SHADES_008 = "#330c0e";
const RED_TINTS_002 = "#ff6369";
const RED_TINTS_004 = "#ff8a8f";
const RED_TINTS_006 = "#ffb1b4";
const RED_TINTS_008 = "#ffd8da";

const WHITE = "#ffffff";

const SKY_BLUE = "#3c92ff";
const PRIMARY_RED = "#e30b0b"; //운항경로선 색상
const BLACK = "#000000";

const GRAY = "#56585c";
const DARK_GRAY = "#313540";
const LIGHT_GRAY = "rgba(128, 128, 128, 0.4)"
const GREEN = "#1d8754";

export {
  RED,
  RED_SHADES_002,
  RED_SHADES_004,
  RED_SHADES_006,
  RED_SHADES_008,
  RED_TINTS_002,
  RED_TINTS_004,
  RED_TINTS_006,
  RED_TINTS_008,
  WHITE,
  SKY_BLUE,
  PRIMARY_RED,
  BLACK,
  GRAY,
  DARK_GRAY,
  LIGHT_GRAY,
  GREEN
};
